import { createActionsHook } from 'src/lib/sweetState';

import { DocumentViewStore } from './DocumentViewStore';

export * from './DocumentViewStore';
export * from './DocumentViewStoreContainer';

export const useDocumentViewActions = createActionsHook(DocumentViewStore);
